import { ref } from 'vue';

const alerts = ref([]);

const addAlert = (
  title,
  status,
  messages = [],
) => {
  alerts.value.push({
    id: Date.now() + Math.random(),
    title,
    status,
    messages: [...messages],
  });
};

const removeAlert = (id) => {
  const tmp = Object.values(alerts.value);
  const index = tmp.findIndex((elm) => elm.id === id);

  if (index >= 0) {
    const start = tmp.slice(0, index);
    const end = tmp.slice(index + 1);

    alerts.value = start.concat(end);
  }
};

const useAlerts = () => (
  {
    alerts,
    addAlert,
    removeAlert,
  }
);

export default useAlerts;
